if (typeof debounce === 'undefined') {
  function debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}
/**
 *  @class
 *  @function ThemeHeader
 */
if (!customElements.get('theme-header')) {
  class ThemeHeader extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.header_section = document.querySelector('.header-section');
      this.menu = this.querySelector('#mobile-menu');
      this.toggle = document.querySelector('.mobile-toggle-wrapper');

      document.addEventListener('keyup', (e) => {
        if (e.code) {
          if (e.code.toUpperCase() === 'ESCAPE') {
            this.toggle.removeAttribute('open');
            this.toggle.classList.remove('active');
          }
        }
      });
      this.toggle.querySelector('.mobile-toggle').addEventListener('click', (e) => {
        if (this.toggle.classList.contains('active')) {
          e.preventDefault();
          document.body.classList.remove('overflow-hidden');
          this.toggle.classList.remove('active');
          this.closeAnimation(this.toggle);
        } else {
          document.body.classList.add('overflow-hidden');
          setTimeout(() => {
            this.toggle.classList.add('active');
          });
        }
        window.dispatchEvent(new Event('resize.resize-select'));
      });

      // Sticky Header Class
      window.addEventListener('scroll', this.setStickyClass.bind(this), {
        passive: true
      });
      // Mobile Menu offset
      window.addEventListener('scroll', this.setHeaderOffset.bind(this), {
        passive: true
      });
      window.addEventListener('scroll', this.setHeaderHeight.bind(this), {
        passive: true
      });

      window.dispatchEvent(new Event('scroll'));

      if (document.querySelector('.announcement-bar-section')) {

        window.addEventListener('scroll', this.setAnnouncementHeight(), {
          passive: true
        });
        window.dispatchEvent(new Event('resize'));
      }

      // Hide header on scroll down, show on scroll up (product page mobile)
      // Uses matchMedia + CSS class so it cleans up when resizing to desktop
      if (document.body.classList.contains('template-product')) {
        const themeHeader = this;
        const mq = window.matchMedia('(max-width: 959px)');   /* = breakpoint mobile da PDP (antes 767 deixava a banda 768-959 com header fixo) */
        let lastScrollY = window.scrollY;
        let scrollHandler = null;
        // gesto no TOPO travado: puxar pra baixo revela o menu (pino segura o
        // reveal contra o rubber-band do iOS); puxar pra cima esconde de novo
        let pinnedTop = false;
        let touchY0 = null;
        let topHideTimer = null;   // ao voltar ao topo, o header fica um tempo antes de recolher
        let touchStartHandler = null, touchMoveHandler = null, touchEndHandler = null, wheelHandler = null;

        function cancelTopHide() {
          if (topHideTimer) { clearTimeout(topHideTimer); topHideTimer = null; }
        }

        function enableMobileHeader() {
          themeHeader.classList.add('mobile-product-hide');
          /* 26/jul: a PRIMEIRA visualização é sem header — a PDP abre imersiva, só a
             obra. Ele entra quando o dedo puxa pra baixo no topo ou quando a página
             volta subindo (antes abria já no header cheio, decisão de 24/jul). */
          lastScrollY = window.scrollY;
          if (!scrollHandler) {
            scrollHandler = function() {
              const currentScrollY = window.scrollY;
              if (currentScrollY > 8) { pinnedTop = false; cancelTopHide(); }
              if (currentScrollY <= 0) {
                /* 26/jul: de volta ao TOPO o header aparece e fica 5s antes de
                   recolher — a primeira vista é imersiva, então ele não pode morar
                   ali. (O recolhimento de 1,6s de 13/jul lia como bug por ser curto;
                   5s dá tempo de usar o menu.) Puxou com o dedo = pinnedTop, e aí
                   ele fica até você mandar embora. */
                if (!pinnedTop && !topHideTimer && themeHeader.classList.contains('mobile-product-show')) {
                  topHideTimer = setTimeout(function () {
                    topHideTimer = null;
                    if (!pinnedTop && window.scrollY <= 0) themeHeader.classList.remove('mobile-product-show');
                  }, 5000);
                }
              } else if (currentScrollY < lastScrollY) {
                themeHeader.classList.add('mobile-product-show');
              } else if (currentScrollY > lastScrollY && currentScrollY > 50) {
                themeHeader.classList.remove('mobile-product-show');
              }
              lastScrollY = currentScrollY;
            };
            window.addEventListener('scroll', scrollHandler, { passive: true });
          }
          if (!touchMoveHandler) {
            // o PINO só vale pra gesto que COMEÇA no topo — chegar ao topo com o
            // dedo ainda arrastando (ou embalo do trackpad) NÃO pina, senão o
            // header trava aberto sem o usuário pedir
            let touchAtTop = false;
            let lastWheelTime = 0;
            touchStartHandler = function(e) {
              touchY0 = e.touches[0].clientY;
              touchAtTop = window.scrollY <= 0;
            };
            touchMoveHandler = function(e) {
              if (touchY0 == null || window.scrollY > 0 || !touchAtTop) return;
              const dy = e.touches[0].clientY - touchY0;
              if (dy > 26 && !pinnedTop) {
                cancelTopHide();
                themeHeader.classList.add('mobile-product-show');
                pinnedTop = true;
              } else if (dy < -26 && (pinnedTop || topHideTimer)) {
                cancelTopHide();
                themeHeader.classList.remove('mobile-product-show');
                pinnedTop = false;
              }
            };
            touchEndHandler = function() { touchY0 = null; touchAtTop = false; };
            wheelHandler = function(e) {
              const now = Date.now();
              const fresh = (now - lastWheelTime) > 350;   // filtra o trem de inércia
              lastWheelTime = now;
              if (window.scrollY > 0) return;
              if (e.deltaY < -8 && !pinnedTop && fresh) {
                cancelTopHide();
                themeHeader.classList.add('mobile-product-show');
                pinnedTop = true;
              } else if (e.deltaY > 8 && (pinnedTop || topHideTimer)) {
                cancelTopHide();
                themeHeader.classList.remove('mobile-product-show');
                pinnedTop = false;
              }
            };
            window.addEventListener('touchstart', touchStartHandler, { passive: true });
            window.addEventListener('touchmove', touchMoveHandler, { passive: true });
            window.addEventListener('touchend', touchEndHandler, { passive: true });
            window.addEventListener('wheel', wheelHandler, { passive: true });
          }
        }

        function disableMobileHeader() {
          themeHeader.classList.remove('mobile-product-hide');
          themeHeader.classList.remove('mobile-product-show');
          pinnedTop = false;
          cancelTopHide();
          if (scrollHandler) {
            window.removeEventListener('scroll', scrollHandler);
            scrollHandler = null;
          }
          if (touchMoveHandler) {
            window.removeEventListener('touchstart', touchStartHandler);
            window.removeEventListener('touchmove', touchMoveHandler);
            window.removeEventListener('touchend', touchEndHandler);
            window.removeEventListener('wheel', wheelHandler);
            touchStartHandler = touchMoveHandler = touchEndHandler = wheelHandler = null;
          }
        }

        function onMqChange(e) {
          if (e.matches) enableMobileHeader();
          else disableMobileHeader();
        }

        if (mq.matches) enableMobileHeader();
        if (mq.addEventListener) mq.addEventListener('change', onMqChange);
        else mq.addListener(onMqChange);
      }

      // Buttons.
      this.menu.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
      this.menu.querySelectorAll('.parent-link-back--button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
    }

    setStickyClass() {
      if (this.classList.contains('header-sticky--active')) {
        let offset = parseInt(this.getBoundingClientRect().top, 10) + document.documentElement.scrollTop;
        this.classList.toggle('is-sticky', window.scrollY >= offset && window.scrollY > 0);
      }
    }
    setAnnouncementHeight() {
      const a_bar = document.getElementById('shopify-section-announcement-bar');
      if (a_bar) {
        let h = a_bar.clientHeight;
        document.documentElement.style.setProperty('--announcement-height', h + 'px');
      }

    }
    setHeaderOffset() {
      let h = this.header_section.getBoundingClientRect().top;
      document.documentElement.style.setProperty('--header-offset', h + 'px');
    }
    setHeaderHeight() {
      let h = this.clientHeight;
      document.documentElement.style.setProperty('--header-height', h + 'px');
    }
    onSummaryClick(event) {
      const summaryElement = event.currentTarget;
      const detailsElement = summaryElement.parentNode;
      const parentMenuElement = detailsElement.closest('.link-container');
      const isOpen = detailsElement.hasAttribute('open');

      if (this.querySelector('.parent-link-back--button')) {
        this.menu.scrollTop = 0;
      }

      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
      }, 100);
    }
    onCloseButtonClick(event) {
      event.preventDefault();
      const detailsElement = event.currentTarget.closest('details');
      this.closeSubmenu(detailsElement);
    }
    closeSubmenu(detailsElement) {
      detailsElement.classList.remove('menu-opening');
      this.closeAnimation(detailsElement);
    }
    closeAnimation(detailsElement) {
      let animationStart;

      const handleAnimation = (time) => {
        if (animationStart === undefined) {
          animationStart = time;
        }

        const elapsedTime = time - animationStart;

        if (elapsedTime < 400) {
          window.requestAnimationFrame(handleAnimation);
        } else {
          detailsElement.removeAttribute('open');
        }
      };

      window.requestAnimationFrame(handleAnimation);
    }
  }
  customElements.define('theme-header', ThemeHeader);
}
/**
 *  @class
 *  @function FullMenu
 */
if (!customElements.get('full-menu')) {
  class FullMenu extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.submenus = this.querySelectorAll('.thb-full-menu>.menu-item-has-children:not(.menu-item-has-megamenu)>.sub-menu');

      if (!this.submenus.length) {
        return;
      }
      const _this = this;
      // resize on initial load
      window.addEventListener('resize', debounce(function () {
        _this.resizeSubMenus();
      }, 100));

      window.dispatchEvent(new Event('resize'));

      document.fonts.ready.then(function () {
        _this.resizeSubMenus();
      });

    }
    resizeSubMenus() {
      this.submenus.forEach((submenu) => {
        let sub_submenus = submenu.querySelectorAll(':scope >.menu-item-has-children>.sub-menu');

        sub_submenus.forEach((sub_submenu) => {
          let w = sub_submenu.offsetWidth,
            l = sub_submenu.parentElement.parentElement.getBoundingClientRect().left + sub_submenu.parentElement.parentElement.clientWidth + 10,
            total = w + l;
          if (total > document.body.clientWidth) {
            sub_submenu.parentElement.classList.add('left-submenu');
          } else if (sub_submenu.parentElement.classList.contains('left-submenu')) {
            sub_submenu.parentElement.classList.remove('left-submenu');
          }
        });
      });
    }
  }
  customElements.define('full-menu', FullMenu);
}